<template>
  <v-row>
    <v-col>
      <v-row align="center" class="mb-4">
        <v-col>
          <v-alert
            v-if="saveError"
            type="error"
            dense
            class="mb-0"
          >
            Não foi possível salvar no momento. Tente novamente.
          </v-alert>

          <v-alert
            v-else-if="hasUnsavedChanges"
            type="warning"
            dense
            class="mb-0"
          >
            <strong>
              Alterações não salvas. Salve antes de mudar de aba.
            </strong>
          </v-alert>
        </v-col>

        <v-col cols="auto">
          <v-btn
            color="primary"
            :loading="saving"
            :disabled="
              disabled ||
              saving ||
              !hasUnsavedChanges
            "
            @click="saveSurgery"
          >
            <v-icon left>
              mdi-content-save
            </v-icon>

            Salvar
          </v-btn>
        </v-col>
      </v-row>

      <Allergy
        :attendance="attendance"
        :showForm="false"
        :allowDelete="false"
      />

      <SurgeryDetail
        :surgery="surgery"
      />

      <ProsthesisList
        :surgeryIndicationProstheses="
          surgery.surgeryIndication.prostheses
        "
        :surgeryIndication="
          surgery.surgeryIndication
        "
        :showForm="false"
        :onlyChosen="true"
        :allowDelete="false"
        :allowEdit="false"
        @update-surgery-indication-prostheses="
          updateProstheses
        "
      />

      <v-row>
        <v-col>
          <v-textarea
            v-model="observation"
            label="Notas"
            placeholder=" "
            hide-details
            outlined
            background-color="white"
            :disabled="disabled"
            @input="handleChange"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-row dense>
            <v-col class="text-h5 gray--text">
              Termos de Consentimento
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <FileUpload
                ownerType="Surgery::ConsementTerm"
                :ownerId="surgery.consementTerm.id"
                :disabled="disabled"
              />
            </v-col>
          </v-row>
        </v-col>

        <v-col>
          <v-row dense>
            <v-col class="text-h5 gray--text">
              Anexos
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <FileUpload
                ownerType="Surgery::Attachment"
                :ownerId="surgery.attachment.id"
                :disabled="disabled"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import ProsthesisList from "@/components/surgery_indication/prosthesis/list/index.vue";
import Allergy from "@/components/medical_record/hpp/allergy.vue";
import SurgeryDetail from "@/components/surgery/detail.vue";

export default {
  name: "SurgeryDetails",

  props: {
    surgery: Object,
    refreshSurgery: Function,
    setSurgeryMoment: Function,

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    ProsthesisList,
    Allergy,
    SurgeryDetail,
  },

  data() {
    return {
      initializing: true,
      saving: false,
      saveError: null,
      initialSnapshot: null,

      observation: "",
    };
  },

  computed: {
    attendance() {
      return this.surgery.attendance;
    },

    hasUnsavedChanges() {
      if (
        this.initializing ||
        this.initialSnapshot === null
      ) {
        return false;
      }

      return (
        this.createSnapshot() !==
        this.initialSnapshot
      );
    },
  },

  async mounted() {
    this.initializing = true;

    this.observation =
      this.surgery.observation || "";

    this.setSurgeryMoment(null);

    await this.$nextTick();

    /*
     * O conteúdo carregado inicialmente passa a ser
     * o baseline para detectar alterações reais.
     */
    this.captureSnapshot();

    this.initializing = false;
  },

  methods: {
    normalizeText(value) {
      return String(value || "")
        .replace(/\r\n/g, "\n")
        .trim();
    },

    createSnapshot() {
      return JSON.stringify({
        observation: this.normalizeText(
          this.observation
        ),
      });
    },

    captureSnapshot() {
      this.initialSnapshot =
        this.createSnapshot();
    },

    handleChange() {
      if (
        this.initializing ||
        this.disabled ||
        this.saving
      ) {
        return;
      }

      /*
       * hasUnsavedChanges já é recalculado
       * automaticamente pelo computed.
       *
       * Aqui apenas limpamos erro anterior quando
       * o operador volta a editar.
       */
      this.saveError = null;
    },

    async saveSurgery() {
      if (
        this.disabled ||
        this.saving ||
        !this.hasUnsavedChanges
      ) {
        return;
      }

      this.saving = true;
      this.saveError = null;

      /*
       * Guarda exatamente o estado enviado.
       */
      const snapshotBeingSaved =
        this.createSnapshot();

      try {
        await this.apolloMutate({
          mutation: require(
            "@/graphql/surgery/save_surgery.gql"
          ),

          variables: {
            surgeryId: this.surgery.id,
            observation: this.observation,
          },
        });

        /*
         * O estado efetivamente persistido passa
         * a ser o novo baseline.
         */
        this.initialSnapshot =
          snapshotBeingSaved;

        await this.refreshSurgery();
      } catch (error) {
        this.saveError = error;

        console.error(
          "Erro ao salvar detalhes da cirurgia:",
          error
        );
      } finally {
        this.saving = false;
      }
    },

    updateProstheses(prostheses) {
      this.surgery.surgeryIndication.prostheses =
        prostheses;
    },
  },
};
</script>

<style lang="scss" scoped></style>
